export default "__VITE_ASSET__DSl_yNb6__"